/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ShareFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m13.58 17.27-5.11-2.79A3.49 3.49 0 0 1 2.5 12a3.5 3.5 0 0 1 5.97-2.48l5.1-2.8A3.52 3.52 0 0 1 17 2.5a3.5 3.5 0 1 1-2.47 5.98l-5.1 2.8a4 4 0 0 1 0 1.45l5.1 2.79A3.49 3.49 0 0 1 20.5 18a3.5 3.5 0 1 1-6.92-.73" />
  </Icon>
);
